export default __webpack_public_path__ + "static/media/VIT.d60927cc.png";